import React from 'react';
import { Video, Play } from 'lucide-react';

interface VideoMessageBubbleProps {
  videoUrl: string | null;
  caption?: string | null;
  fileName?: string | null;
  timestamp?: string;
}

export const VideoMessageBubble: React.FC<VideoMessageBubbleProps> = ({ 
  videoUrl, 
  caption,
  fileName,
  timestamp 
}) => {
  return (
    <div className="flex justify-end mb-2">
      <div className="bg-[#DCF8C6] rounded-lg overflow-hidden max-w-[85%] shadow-sm">
        {videoUrl ? (
          <div className="relative">
            <video 
              src={videoUrl} 
              className="w-full max-w-[250px] h-auto rounded-t-lg"
              controls={false}
            />
            <div className="absolute inset-0 bg-black/30 flex items-center justify-center">
              <div className="w-14 h-14 rounded-full bg-white/90 flex items-center justify-center">
                <Play className="h-6 w-6 text-gray-800 ml-1" fill="currentColor" />
              </div>
            </div>
          </div>
        ) : (
          <div className="w-[250px] h-[150px] bg-gray-200 flex flex-col items-center justify-center gap-2">
            <Video className="h-12 w-12 text-gray-400" />
            {fileName && (
              <p className="text-xs text-gray-500">{fileName}</p>
            )}
          </div>
        )}
        
        {caption && (
          <div className="px-3 py-2">
            <p className="text-sm text-gray-800 whitespace-pre-wrap break-words">
              {caption}
            </p>
          </div>
        )}
        
        <div className="flex justify-end items-center gap-1 px-3 pb-2">
          <span className="text-[10px] text-gray-600">
            {timestamp || new Date().toLocaleTimeString('es', { hour: '2-digit', minute: '2-digit' })}
          </span>
        </div>
      </div>
    </div>
  );
};
